import withNavigate from "../../../routes/withNavigate";
import MailSenderContainer from "./MailSenderContainer.jsx";
import MailSenderStore from "./MailSenderStore";

export default MailSenderStore(withNavigate(MailSenderContainer));